export const REACT_APP_API_DOMAIN = "https://sp.zalo.me/ajax";

export enum ACTION {
  CHECK_SESSION = 10,
  FOLLOW = 9,
  CHECK_FOLLOW = 20,
}

const convertObjToFormData = (obj: any) => {
  var formBody = [];
  for (var item in obj) {
    var encodedKey = encodeURIComponent(item);
    var encodedValue = encodeURIComponent(obj[item]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  return formBody.join("&");
};

export const checkHaveSession = () =>
  new Promise((resolve: any, reject: any) => {
    const formData = convertObjToFormData({
      action: ACTION.CHECK_SESSION,
    });
    window
      .fetch(REACT_APP_API_DOMAIN, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        credentials: "include",
        referrerPolicy: "origin",
        body: formData,
      })
      .then((rs) => {
        const data = rs.json();
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const onRequestFollow = (entry: any) =>
  new Promise((resolve: any, reject: any) => {
    const formData = convertObjToFormData({
      ...entry,
      action: ACTION.FOLLOW,
    });

    window
      .fetch(REACT_APP_API_DOMAIN, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        credentials: "include",
        referrerPolicy: "origin",
        body: formData,
      })
      .then((rs) => {
        const data = rs.json();
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const onRequestCheckFollow = (entry: any) =>
  new Promise((resolve: any, reject: any) => {
    const formData = convertObjToFormData({
      ...entry,
      action: ACTION.CHECK_FOLLOW,
    });

    window
      .fetch(REACT_APP_API_DOMAIN, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        credentials: "include",
        referrerPolicy: "origin",
        body: formData,
      })
      .then((rs) => {
        const data = rs.json();
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
